module.exports = __webpack_public_path__ + "img/entityFramework.2dd41655.svg";